import { render, staticRenderFns } from "./studio_follow_customer.vue?vue&type=template&id=ccdc98b6&"
import script from "./studio_follow_customer.vue?vue&type=script&lang=js&"
export * from "./studio_follow_customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports